import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getClientCategories } from "api/services/client-categories";
import FloatingButton from "components/FloatingButton";
import Loader from "components/Loader";
import SearchContainer from "components/SearchContainer";
import { snack } from "components/toast";
import ValidateAccess from "components/ValidateAccess";
import { usePermissions } from "context/PermissionsProvider";
import { UserProfileContext } from "context/UserProfile";
import { Permissions } from "data/permissons";
import useTitle from "hooks/useTitle";
import { useContext, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import AddCategory from "views/settings/clientcategories/AddCategory";
import CategoryCard from "views/settings/clientcategories/CategoryCard";



function ClientCateogries() {
  useTitle(
    "Client Categories",
  );
  const [open, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [sortBy, setSortBy] = useState("");
  const [categoriesData, setCategoriesData] = useState<any>([])
  const { permissions } = usePermissions();
  const { data: uData } = useContext(UserProfileContext);


  const { data, isLoading }: ResType = useQuery(
    "client-categories",
    getClientCategories, {
    onSuccess: (response) => {
      if (response && response?.data && response?.data?.length) {
        setCategoriesData(response.data);
      } else {
        setCategoriesData([]);
      }
    },
    onError: (err) => {
      if (!err?.error) {
        snack.error("An error occurred while fetching categories");
      }
    }
  });

  const getData = () => {
    let result = [...categoriesData];

    if (search) {
      result = result.filter((item) =>
        item.name
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    // default categories first
    result = result.sort((a: any, b: any) => {
      if (a.default_one === b.default_one) {
        return 0;
      }

      return a.default_one ? -1 : 1;
    });

    if (sortBy === "a_z") {
      result = result.sort((a: any, b: any) => {
        if (a.default_one !== b.default_one) {
          return a.default_one ? -1 : 1;
        }

        return a.name.localeCompare(b.name);
      });
    }

    if (sortBy === "z_a") {
      result = result.sort((a: any, b: any) => {
        if (a.default_one !== b.default_one) {
          return a.default_one ? -1 : 1;
        }

        return b.name.localeCompare(a.name);
      });
    }

    return result;
  };

  
  if (uData?.role?.name !== "Admin") {
    if (!(permissions.includes(Permissions.VIEW_CLIENT_CATEGORIES))) {
      return <AccessDenied />
    }
  }

  if (isLoading) return <Loader />;

  return getData().length ? (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Box display="flex" gap={2} flex={1}>
          <SearchContainer
            value={search}
            minWidth="300px"
            onChange={setSearch}
            placeHolder="Search categories"
          />
          <TextField
            sx={{ minWidth: 120 }}
            select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            size="small"
            variant="outlined"
            label="Sort By"
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="a_z">A - Z</MenuItem>
            <MenuItem value="z_a">Z - A</MenuItem>
          </TextField>
        </Box>
        {/* <Box display="flex" gap={1}>
          <Button
            onClick={() => setOpenImport(true)}
            variant="outlined"
            startIcon={<Add />}
            color="secondary"
          >
            Import from Vider
          </Button>
          <Button
            onClick={handleUpdate}
            variant="outlined"
            startIcon={<Update />}
            color="secondary"
          >
            Update Vider Categories
          </Button>
        </Box> */}
      </Box>
      {/* <Paper
        sx={{
          border: "1px solid #BDBDBD",
          height: "480px",
          overflowY: "scroll",
          p: 1,
          backgroundColor: "inherit",
        }}
      > */}
      <Grid container spacing={2} mt={1}>
        {getData()?.map((item: any, index: any) => (
          <Grid item xs={4} key={index}>
            <CategoryCard data={item} />
          </Grid>
        ))}
      </Grid>
      {/* </Paper> */}
      <AddCategory open={open} setOpen={setOpen} />
      <ValidateAccess name={Permissions.CREATE_CLIENT_CATEGORIES}>
        <Box>
          <FloatingButton
            onClick={() => {
              setOpen(true);
            }}
          />
        </Box>
      </ValidateAccess>
    </Box>
  ) : (<Box p={3}>
    <Box display="flex" justifyContent="space-between" mb={2}>
      <Box display="flex" gap={2} flex={1}>
        <SearchContainer
          value={search}
          minWidth="300px"
          onChange={setSearch}
          placeHolder="Search categories"
        />
        <TextField
          sx={{ minWidth: 120 }}
          select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          size="small"
          variant="outlined"
          label="Sort By"
        >
          <MenuItem value="">None</MenuItem>
          <MenuItem value="a_z">A - Z</MenuItem>
          <MenuItem value="z_a">Z - A</MenuItem>
        </TextField>
      </Box>
      <Box display="flex" gap={1}>
        {/* <Button
          onClick={() => setOpenImport(true)}
          variant="outlined"
          startIcon={<Add />}
          color="secondary"
        >
          Import from Vider
        </Button>
        <Button
          onClick={handleUpdate}
          variant="outlined"
          startIcon={<Update />}
          color="secondary"
        >
          Update Vider Categories
        </Button> */}
      </Box>
    </Box>
    {/* <Paper
      sx={{
        border: "1px solid #BDBDBD",
        height: "480px",
        overflowY: "scroll",
        p: 1,
        backgroundColor: "inherit",
      }}
    > */}


    <Typography variant="subtitle2" color="rgba(0,0,0,0.5)" align="center" mt={20}>
      No data
    </Typography>

    {/* </Paper> */}
    {/* <AddCategory open={open} setOpen={setOpen} />
    <ValidateAccess name={Permissions.CREATE_CATEGORIES}>
      <Box>
        <FloatingButton
          onClick={() => {
            setOpen(true);
          }}
        />
      </Box>
    </ValidateAccess> */}
  </Box>)
}

export default ClientCateogries;
